'use strict';
import api from 'utils/api';
import Immutable from 'immutable';
import flatten from 'lodash/array/flatten';
import queryString from 'query-string';

const MediaSource = (alt) => {
    return {
        loadMedia: {
            local(state, params) {
                var cached = state._cache[JSON.stringify(params)] || null;
                if (cached) {
                    alt.getActions('media').loadMediaSuccess(cached);
                    return true;
                }
            },
            remote(state, params) {
                return api.get('media', params).then((data) => {
                    return {data, params};
                });
            },
            success: alt.getActions('media').loadMediaSuccess,
            error: alt.getActions('media').loadMediaError
        },
        loadLandingPage: {
            local(state) {
                return state.landingPage.size !== 0 ? state.landingPage.toJS() : null;
            },
            remote() {
                return api.get('landing_pages');
            },
            success: alt.getActions('media').loadLandingPageSuccess,
            error: alt.getActions('media').loadLandingPageError
        },
        checkQuota: {
            remote(state, params) {
                return api.get('request_download', params);
            },
            success: alt.getActions('media').checkQuotaSuccess,
            error: alt.getActions('media').checkQuotaError
        }
    };
};

export default class MediaStore {
    constructor() {
        this.bindActions( this.alt.getActions('media') );
        this.registerAsync( MediaSource );

        // Make the UI even more Snappy
        // by caching media query during the session
        this._cache = {};

        // Exposed
        this.media = Immutable.fromJS([]);
        this.filters = Immutable.fromJS([]);
        this.landingPage = Immutable.fromJS({});
        this.selectedFilters = Immutable.fromJS([]);
        this.meta = Immutable.fromJS({});
        this.params = {};
        this.isExpanded = false;
        this.quotaExceeded = false;
    }

    /**
     * Load Media and generate Filters
     * @param  {[type]} result [description]
     * @return {[type]}        [description]
     */
    onLoadMediaSuccess( result ) {
        var data = result.data;
        this._cache[ JSON.stringify( result.params ) ] = result;

        this.filters = Immutable.fromJS( data.filter );
        this.meta = Immutable.fromJS( data.meta );
        this.media = Immutable.fromJS( data.items );
        this.params = result.params;

        // Active Filters from selections
        var activeFilters = flatten( data.activeFilters ).map( afilter => {
            var _afilter = { ...afilter };
            _afilter.params = queryString.parse( afilter.params );
            var params = queryString.parse( afilter.params );
            return _afilter;
        });

        // Active Filters from search
        if ( this.params.search_id ) {
            activeFilters.push({
                name: data.meta.search_name || 'SEARCH',
                params: result.params
            });
        }
        else if ( this.params.search ) {
            activeFilters.push({
                name: this.params.search,
                params: { 'search': this.params.search }
            });
        }

        this.selectedFilters = Immutable.fromJS( activeFilters );
    }

    onLoadMediaError( err ) {
        console.warn( 'onLoadMediaError', err );
    }

    onLoadLandingPageSuccess( landingPage ) {
        this.landingPage = Immutable.fromJS( landingPage );
    }

    onCheckQuotaSuccess( result ) {
        this.quotaExceeded = !result.success;
    }

    onCheckQuotaError( err ) {

    }

    onClearSearch() {
        delete this.params.search;
    }

    onCloseBasket( id ) {
        const ix = this.media.findIndex( item => item.get('id') === id );
        this.media = this.media.updateIn( [ ix, '_basket' ], active => false );
    }

    onToggleFilter( ix ) {
        this.filters = this.filters.updateIn( [ ix, 'active' ], active => !active );
    }

    onToggleItemSelection( id ) {
        const ix = this.media.findIndex( item => id === item.get('id') && false !== item.get('showdownload') );
        if ( ix > -1 ) {
            this.media = this.media.updateIn( [ ix, '_checked' ], active => !active );
        }
    }

    onToggleBasket( id ) {
        const ix = this.media.findIndex( item => item.get('id') === id );
        this.media = this.media.updateIn( [ ix, '_basket' ], active => !active );
    }

    onToggleAllItemSelection() {
        const eligible     = this.media.filter( item => false !== item.get('showdownload') );
        const countChecked = eligible.filter( item => item.get('_checked') === true ).size;
        const shouldCheck  = ( countChecked !== eligible.size );

        this.media = this.media.map( item => {
            if ( false !== item.get('showdownload') ) {
                item = item.set( '_checked', shouldCheck );
            }
            return item;
        });
    }

    onRemoveAllItemSelection() {
        this.media = this.media.map( item => item.set( '_checked', false ) );
    }

    onCloseFilters() {
        this.filters = this.filters.map( filter => filter.set( 'active', false ) );
    }

    toggleExpand() {
        this.isExpanded = !this.isExpanded;
        this.filters = this.filters.map( filter => filter.set( 'active', this.isExpanded ) );
    }

    toggleItemAddedNotification( data ) {
        const { mediaId, basketName } = data;
        const ix = this.media.findIndex( item => mediaId === item.get('id') );
        this.media = this.media.updateIn( [ ix, '_notification' ], notification => ( notification ? false : basketName ) );
    }

    onRemoveSelectedFilter( index ) {
        this.selectedFilters = this.selectedFilters.filter( ( filter, i ) => {
            return i !== index
        });
    }
}



// WEBPACK FOOTER //
// ./app/stores/mediaStore.js